import {getAllApps} from "../app_maker";
import {isNull, isTrue} from "../../../utils/utils";

export const convertMapStateToUrlParams = (mapState) => {
	return `slideId=${mapState?.slide?.id || mapState?.slideId || mapState?.id}&x=${mapState.x}&y=${mapState.y}&z=${mapState.z}&r=${mapState.r}&digitalZoomStatus=${mapState.digitalZoomStatus}`;
}

export const convertGammaStateToUrlParams = (gammaState) => {
	if (isNull(gammaState.topApp) || isNull(gammaState.bottomApp))
		return `sync=${gammaState.sync}&tileMapEnable=${gammaState.tileMapEnable}&bloodMapEnable=${gammaState.bloodMapEnable}`;
	return `sync=${gammaState.sync}&tileMapEnable=${gammaState.tileMapEnable}&bloodMapEnable=${gammaState.bloodMapEnable}&topApp=${gammaState.topApp.id}&bottomApp=${gammaState.bottomApp.id}`;
}

export const getMapsStateFromUrl = () => {
	let urlPart = window.location.href.split('?')[1];
	if (!urlPart) return [];

	return urlPart.split('#').map(params =>
		params.split('&').reduce((mapState, param) => {
			let [key, value] = param.split('=');
			switch (key) {
				case 'slideId':
					mapState.slideId = value;
					return mapState;
				case 'x':
					mapState.x = value ? parseFloat(value) : -1;
					return mapState;
				case 'y':
					mapState.y = value ? parseFloat(value) : -1;
					return mapState;
				case 'z':
					mapState.z = value ? parseFloat(value) : 0;
					return mapState;
				case 'r':
					mapState.r = value ? parseFloat(value) : 0;
					return mapState;
				case 'digitalZoomStatus':
					mapState.digitalZoomStatus = value ? value.toLowerCase() === 'true' : false;
					return mapState;
				default:
					return mapState;
			}
		}, {})).filter(mapState => mapState.slideId);
}

export const getGammaStateFromUrl = () => {
	let urlPart = window.location.href.split('?')[2];
	if (!urlPart) return {};

	return urlPart.split('&').reduce((gammaState, param) => {
		let [key, value] = param.split('=');
		switch (key) {
			case 'sync':
				gammaState.sync = value ? value.toLowerCase() === 'true' : false;
				return gammaState;
			case 'topApp':
				gammaState.topApp = value ? getAllApps().find(app => app.id === value) : false;
				return gammaState;
			case 'bottomApp':
				gammaState.bottomApp = value ? getAllApps().find(app => app.id === value) : false;
				return gammaState;
			case 'tileMapEnable':
				gammaState.tileMapEnable = isTrue(value);
				return gammaState;
			case 'bloodMapEnable':
				gammaState.bloodMapEnable = isTrue(value);
				return gammaState;
			default:
				return gammaState;
		}
	}, {});
}
